require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-food-truck-for-a-cause.json") })
        }
      }, "path---news-food-truck-for-a-cause");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-food-truck-for-a-cause!./.cache/json/news-food-truck-for-a-cause.json
// module id = 808
// module chunks = 231608221292675